module.exports = __webpack_public_path__ + "static/media/Life @revfin2.534cf419.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/events/Life @revfin2.webp
// module id = 325
// module chunks = 0